import React, { useState } from 'react';
import DatePicker from "react-datepicker";
import Image from '../image';
import "react-datepicker/dist/react-datepicker.css";

const ReactDOB = (props) => {
  const ExampleCustomInput = ({ placeholder, value, onClick }) => (
    <input type='text' className="datePickerReact txtbox" placeholder={placeholder} onClick={onClick} value={value} />
  );

  return (
    <div className="calender_position"> 
    <DatePicker
      dateFormat="dd/MM/yyyy"
      name={props.name}
      selected={props.value}
      onChange={props.onChange}
      onBlur={props.onBlur}
      placeholderText={props.placeholder}
      minDate={props.minDate}
      maxDate={props.maxDate}
      disabled={props.disabled}
      class={props.class}
      // customInput={<ExampleCustomInput />}
      customInput={<CustomInput />}
      dayClassName={props.dayClassName}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
    />
    </div>
  )
}

export default ReactDOB


const CustomInput = React.forwardRef((props, ref) => {
   
  return (
    <div className="txtbox Custfocus" onClick={props.onClick}>
      <label  ref={ref}>
        {props.value || props.placeholder}
      </label>
      <Image image="/assets/images/category/calendar_icon.svg" class="sy_Celender" onClick={props.onClick} alt="calendar" />   
      {/* <FontAwesomeIcon icon={faCalendarAlt}  /> */}
    </div>
  );
});